import React from 'react';
import { Link } from 'react-router-dom';
import { ILink } from '../../../types/common';
import { isExternal } from '../../utils/prepareButtonAttrs';

interface WrapperLinkProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  url?: string | ILink;
  children: React.ReactNode;
}

export const WrapperLink: React.FC<WrapperLinkProps> = ({
  className,
  url,
  style,
  children,
}) => {
  if (!url)
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );

  const transformedUrl = typeof url === 'string' ? url : url.link;
  const transformedTarget =
    typeof url === 'string' || url.targetBlank ? '_blank' : '_self';

  return isExternal(url) ? (
    <a
      href={transformedUrl}
      target={transformedTarget}
      rel="noreferrer"
      className={className}
      style={style}
    >
      {children}
    </a>
  ) : (
    <Link to={transformedUrl} className={className} style={style}>
      {children}
    </Link>
  );
};
